<template>
	<div class="row">
		<div class="mr-auto ml-auto  col-lg-10">
			<button @click="$emit('addNewProfile')" class="btn btn-primary">
				<i class="fa fa-plus" aria-hidden="true" />
				{{ 'Add Group' | translate }}
			</button>
			<!-- <button
       :disabled='checkedProfile.length === 0'
       class="btn btn-secondary"
       @click.prevent='openModal(checkedProfile, "email")'>
        {{ 'Send email' | translate }}
      </button>
      <button class="btn btn-secondary">
        <i class="fa fa-file-excel-o" aria-hidden="true"/>
        {{ 'Download' | translate }}
      </button> -->
			<div class="table-responsive">
				<table class="table">
					<tr>
						<th>{{ 'Start' | translate }}</th>
						<!-- <th>
							<input @change="checkAll" v-model="checkAllInput" type="checkbox" />
						</th> -->
						<th>{{ 'Group nickname' | translate }}</th>
						<th>{{ 'Group name' | translate }}</th>
						<!-- <th>{{ 'Group address' | translate }}</th> -->
						<th>{{ 'Group statistics' | translate }}</th>
						<th>{{ 'Homework' | translate }}</th>
						<th>{{ 'Teacher' | translate }}</th>
						<th>{{ 'Students' | translate }}</th>
						<th>{{ 'Parents' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>
					<tr :key="group.id" v-for="group in listProfiles">
						<td :class="group.age === 'Junior'
				? 'junior'
				: group.age === 'Average'
					? 'average'
					: group.age === 'Older'
						? 'older'
						: 'ageClass'
				">
							{{ group.lessons_starts | month | translate }}
						</td>
						<!-- <td>
							<input v-model="checkedProfile" :value="group.id" type="checkbox" ref="input" />
						</td> -->
						<td>
							<router-link :to="{
				name: 'Dashboard Group Profile',
				params: { id: group.id },
			}">{{ group.name }}</router-link>
						</td>
						<td>
							<div>{{ $t(group.age) }}</div>
							<div>{{ group.lessons_starts }}</div>
							<div>{{ group.lesson_time }}</div>
							<div>{{ workDays(group.working_days) }}</div>
						</td>
						<!-- <td>
							<div>{{ group.district }}</div>
							<div>{{ group.street }}</div>
							<div>{{ group.location_name }}</div>
							<div>{{ group.address }}</div>
						</td> -->
						<td>
							<router-link class="outline" :to="{
				name: 'Dashboard List',
				query: { group: group.id, statistics: true },
				params: { role: 'student' },
			}">{{ 'Group statistics' | translate }}</router-link>
						</td>
						<td @click="setProfileName(group.name)">
							<router-link class="outline" :to="{ name: 'Group Homework', params: { id: group.id } }">{{ 'Assign' |
				translate }}</router-link>
						</td>
						<td>
							<router-link :to="{
				name: 'Dashboard Profile',
				params: { id: group.teacher },
			}">
								<div>{{ group.teacher_first_name }}</div>
								<div>{{ group.teacher_last_name }}</div>
								<div>{{ group.teacher_middle_name }}</div>
							</router-link>
						</td>
						<td>
							<router-link v-b-tooltip.hover :title="$t(`total`)" :to="{
				name: 'Dashboard List',
				query: { group: group.id },
				params: { role: 'student' },
			}">{{ group.count_students }}</router-link>
							/
							<router-link v-b-tooltip.hover :title="$t(`active`)" :to="{
				name: 'Dashboard List',
				query: { group: group.id },
				params: { role: 'student' },
			}">{{ group.count_students_active }}</router-link>
							/
							<router-link v-b-tooltip.hover :title="$t(`blocked`)" :to="{
				name: 'Dashboard List',
				query: { group: group.id },
				params: { role: 'student' },
			}">{{ group.count_students_inactive }}</router-link>
						</td>
						<td>
							<router-link :to="{
				name: 'Dashboard List',
				query: { group: group.id },
				params: { role: 'parent' },
			}">{{ group.count_parents }}</router-link>
						</td>
						<td>
							<!-- <a href="#" @click.prevent="openModal(profile.id, 'email')">{{
								'Send email' | translate
							}}</a> -->
							<a href="#" class="outline" @click.prevent="createStudent(group.id)">
								<i class="fa fa-plus" aria-hidden="true" />
								{{ 'Add Student' | translate }}
							</a>
							<a href="#" class="outline" @click.prevent="openModal(group.id, 'lessons')">
								{{ 'Lessons' | translate }}
							</a>
							<a href="#" class="outline" @click.prevent="showModalIndigoDollars = group.id">
								{{ 'Indigo-dollars' | translate }}
							</a>
							<a href="#" class="outline" @click.prevent="showModalAddNotification = group.id">
								{{ 'modalAddNotification.title' | translate }}
							</a>
							<a href="#" @click.prevent="openModal(group.id, 'delete')" class="text-red outline outline-red">{{ 'Block'
				|
				translate }}</a>
						</td>
					</tr>
				</table>

				<ModalIndigoDollaras :groupId="showModalIndigoDollars" :show="!!showModalIndigoDollars"
					@close="showModalIndigoDollars = false" />

				<ModalAddNotification :groupId="showModalAddNotification" :show="!!showModalAddNotification"
					@close="showModalAddNotification = false" />
			</div>
		</div>
	</div>
</template>

<script>
import ModalAddNotification from '../Modal/AddNotification'
import ModalIndigoDollaras from '../Modal/IndigoDollars'
export default {
	name: 'Group',
	data() {
		return {
			showModalIndigoDollars: false,
			showModalAddNotification: false,
			checkAllInput: false,
			checkedProfile: [],
		}
	},
	computed: {
		listProfiles() {
			console.log(this.$store.state.profiles)

			return this.$store.state.profiles
		},
	},
	methods: {
		createStudent(val) {
			this.$store.commit('changeForGroup', val)
			this.$router.push({ name: 'Dashboard Add', params: { role: 'student' } })
		},
		checkAll() {
			this.checkedProfile = []
			if (this.checkAllInput) {
				this.listProfiles.forEach(item => {
					this.checkedProfile.push(item.id)
				})
			}
		},
		setProfileName(name) {
			this.$store.state.homeworkProfileName = name
		},
		openModal(id, type) {
			if (typeof id === 'number') {
				let profileArr = []
				profileArr.push(id)
				this.$store.commit('changeModalId', profileArr)
			} else {
				this.$store.commit('changeModalId', id)
			}
			this.$store.commit('changeModalType', type)
			this.$emit('openModal')
		},
		workDays(val) {
			if (!val) {
				return ''
			}
			let daysArr = []
			val.forEach(item => {
				daysArr.push(this.$t(item))
			})
			return daysArr.join(', ')
		},
	},
	components: {
		ModalIndigoDollaras,
		ModalAddNotification,
	},
	filters: {
		month(val) {
			if (val) {
				switch (val.substr(5, 2)) {
					case '01':
						return 'January'
					case '02':
						return 'February'
					case '03':
						return 'March'
					case '04':
						return 'April'
					case '05':
						return 'May'
					case '06':
						return 'June'
					case '07':
						return 'July'
					case '08':
						return 'August'
					case '09':
						return 'September'
					case '10':
						return 'October'
					case '11':
						return 'November'
					case '12':
						return 'December'
				}
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
table {
	overflow: hidden;
}

tr {
	padding: 7px 0;
}

.junior {
	border-left: 3px solid #f1c40f;
}

.average {
	border-left: 3px solid #2ecc71;
}

.older {
	border-left: 3px solid #9b59b6;
}

.ageClass {
	border-left: 3px solid #e67e22;
}

td:first-child {
	transform: rotate(270deg);
	position: relative;
	left: 35px;
	top: 0px;
	width: 29px;
	padding: 0;
	font-size: 12px;
	text-align: center;
}

@media (max-width: 576px) {
	.offset-lg-1>.btn {
		width: 100%;
		margin-bottom: 10px;
	}
}
</style>
